import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-englisch.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')